import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TabContent, TabPane } from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.css';
import './App.scss';

import ObjectViews from '../components/ObjectViews';
import Navigation from '../components/Nav';
import Loader from '../components/Loader';
import Header from '../components/Header';

// import Splitter from 'm-react-splitters';
// import 'm-react-splitters/lib/splitters.css';

import Application from '../views/Application';
import Calculate from '../views/Calculate';
import Design from '../views/Design';
import Dimension from '../views/Dimension';
import Loads from '../views/Loads';
import Material from '../views/Material';
import Options from '../views/Options';

import initService from '../services/requests/init.service';

import TABS from './tabs';
import Notification from '@components/Notification';

// import { APP_TEXTS } from '../texts/texts';

// import MediaQuery from 'react-responsive';

//const AppRightSideTabs = (props) => {
//  return (
//    <div className="p-2 application__tabs tabs">
//      <button className="tabs__button" onClick={props.showOptions}>Options</button>

//      <div className={`tabs__wrapper ${props.isOptions && 'active'}`}>
//        <button className="tabs__button" onClick={props.hideOptions}>Close</button>

//        <Navigation tabs={TABS} activeTab={props.activeTab} toggle={props.setActiveTab} />

//        <TabContent activeTab={props.activeTab}>
//          <TabPane tabId={TABS.OPTIONS}> <Options /> </TabPane>
//          <TabPane tabId={TABS.APPLICATION}> <Application /> </TabPane>
//          <TabPane tabId={TABS.DIMENSION}> <Dimension /> </TabPane>
//          <TabPane tabId={TABS.MATERIAL}> <Material /> </TabPane>
//          <TabPane tabId={TABS.LOADS}> <Loads /> </TabPane>
//          <TabPane tabId={TABS.DESIGN}> <Design /> </TabPane>
//          <TabPane tabId={TABS.CALCULATE}> <Calculate /> </TabPane>
//        </TabContent>
//      </div>
//    </div>
//  );
//};
import UnitsForm from "@components/UnitsForm";
import { APP_TEXTS } from '../texts/texts';
import Editor from '@components/Editor';
import { APP_STATES, BRAND } from '@config';
import Spinner from '@components/LoadingStyles/Spinner';
import ResizablePanels from '@components/ResizablePanels';
import Popup from 'reactjs-popup';
import { brandList, countryList } from '../app.values';

// const navigations = [
//   {
//     key: TABS.OPTIONS,
//     value: APP_TEXTS.OPTIONS.Content
//   },
//   {
//     key: TABS.APPLICATION,
//     value: APP_TEXTS.APPLICATIONS.Content
//   },
//   {
//     key: TABS.DIMENSION,
//     value: APP_TEXTS.DIMENSIONS.Content
//   },
//   {
//     key: TABS.MATERIAL,
//     value: APP_TEXTS.NAV_MATERIAL.Content
//   },
//   {
//     key: TABS.LOADS,
//     value: APP_TEXTS.NAV_LOADS.Content
//   },
//   {
//     key: TABS.DESIGN,
//     value: APP_TEXTS.NAV_DESIGN.Content
//   },
//   {
//     key: TABS.CALCULATE,
//     value: APP_TEXTS.NAV_CALCULATE.Content
//   }
// ];

class App extends Component {
  
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func.isRequired,
    isEditor: PropTypes.bool.isRequired,
    init: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this._isMounted = false;

    // Bind the this context to the handler function
    this.forceRender = this.forceRender.bind(this);
    initService.initDefault();

    this.state = {
      isOptions: false,
      isLoader: false,
      refresh: true
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // This method will be sent to the child component
  forceRender() {
    if (this._isMounted) {
      // Force a render with a simulated state change
      this.setState({refresh: !this.state.refresh});
    }
  }

  /*
  renderAppSimple() {
    return (
      <React.Fragment>
        <ObjectViews className="application__views" init={this.props.init} />
        <AppRightSideTabs 
        showOptions={this.showOptions}
        isOptions={this.state.isOptions}
        hideOptions={this.hideOptions}
        activeTab={this.props.activeTab} />
      </React.Fragment>
    );
  }
 
  renderAppWithSlider() {
    return (
      <Splitter position="vertical"
        primaryPaneMaxWidth="80%"
        primaryPaneMinWidth={0}
        primaryPaneWidth="100%"
        postPoned={false}
        dispatchResize={true}>
 
        <ObjectViews className="application__views" init={this.props.init} />
        <AppRightSideTabs 
        showOptions={this.showOptions}
        isOptions={this.state.isOptions}
        hideOptions={this.hideOptions}
        activeTab={this.props.activeTab} />
 
      </Splitter>
    );
  }
  */

  render() {
    return (
      <React.Fragment>
      <Popup 
          className="default_popup"
          modal={true}
          open={!window.sessionStorage.getItem('disclaimerAccepted')}
          closeOnDocumentClick={false}
        >
        {close => disclaimerContent(() =>
          {
            window.sessionStorage.setItem('disclaimerAccepted', "true");
            close();
          }, 
          false,
          getCountryForDisclaimer(this.props.appStatus, this.props.country))}
      </Popup>
      <div className="app">
        <Header className="app__header" changeTab={this.props.setActiveTab} />
          
        {this.props.appStatus === APP_STATES.LOADING_NEW_STATE && (
          <Spinner/>
        )}
        <main className="app__content-block">
          <div className="application app__views-containers">
            <Loader isActive={this.state.isLoader} />

            <ResizablePanels panels={2}>
              <ObjectViews key="scene" className="application__views" init={this.props.init} minwidth={334}/>
             
              <div key="menu" className="p-2 application__tabs tabs" minwidth={666}>
                <button className="tabs__button" onClick={this.showOptions}>{APP_TEXTS.MENU_OPTIONS.Content}</button>

                {!this.props.isEditor && (
                <div className={`tabs__wrapper ${this.state.isOptions && 'active'}`}>
                  <div className="sticky-header">
                    <button className="tabs__button" onClick={this.hideOptions}>{APP_TEXTS.CLOSE.Content}</button>

                    <Navigation 
                      tabs={TABS} 
                      activeTab={this.props.activeTab} 
                      toggle={this.props.setActiveTab} 
                      refresh={this.state.refresh}
                      allowCalculation={this.props.allowCalculation}
                    />
                  </div>

                  <TabContent activeTab={this.props.activeTab}>
                    <TabPane tabId={TABS.OPTIONS}> <Options action={this.forceRender} /> </TabPane>
                    <TabPane tabId={TABS.APPLICATION}> <Application /> </TabPane>
                    <TabPane tabId={TABS.DIMENSION}> <Dimension /> </TabPane>
                    <TabPane tabId={TABS.MATERIAL}> <Material /> </TabPane>
                    <TabPane tabId={TABS.LOADS}> <Loads /> </TabPane>
                    <TabPane tabId={TABS.DESIGN}> <Design /> </TabPane>
                    <TabPane tabId={TABS.CALCULATE}> <Calculate /> </TabPane>
                  </TabContent>
                </div>
                )}

                {this.props.isEditor && (
                  <div className={`tabs__wrapper ${this.state.isOptions && 'active'}`}>
                    <button className="tabs__button" onClick={this.hideOptions}>
                      {APP_TEXTS.CLOSE.Content}
                    </button>
                    <Editor />
                  </div>
                )}
              </div>
              
            </ResizablePanels>
          </div>
        </main>

        <div className="app__units-row">
          <div className="project-name">
            {this.props.projectName}
          </div>
          <UnitsForm isUnitRow="true"/>
        </div>

        <Notification className="notification"/>
      </div>
      </React.Fragment>
    );
  }

  showOptions = () => {
    this.setState({ isOptions: true });
  };

  hideOptions = () => {
    this.setState({ isOptions: false });
  };

}

export function getCountryForDisclaimer(appStatus, country) {
  if (appStatus === APP_STATES.NOT_INITIALIZED) {
    return initService.getBrowserCountry();
  } else {
    return country;
  }
}

export function disclaimerContent(close, isPrivacyPolicy, country) {
  return (
    <React.Fragment>
      <h4 className="default_popup-header mb-2 ml-2">
        {isPrivacyPolicy ? APP_TEXTS.PRIVACY_POLICY_HEADER.Content : APP_TEXTS.DISCLAIMER_HEADER.Content}
      </h4>
      <section className="list-type default_popup-text">
        <div className="content">
        {!isPrivacyPolicy && (<p><b>{APP_TEXTS.DISCLAIMER_TITLE.Content}</b></p>)}
          {BRAND === brandList.Spit ? (
              <React.Fragment>
                <p>{APP_TEXTS.DISCLAIMER_SPIT_CONTENT_1.Content}</p>
                <p>{APP_TEXTS.DISCLAIMER_SPIT_CONTENT_2.Content}</p>
              </React.Fragment>
            ) : (BRAND === brandList.Redhead ? 
              (Number(country) === countryList["Canada"] ?
                (
                  <React.Fragment>
                    <p>{APP_TEXTS.DISCLAIMER_CANADA_CONTENT_1.Content}</p>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <p>{APP_TEXTS.DISCLAIMER_REDHEAD_CONTENT_1.Content}</p>
                  </React.Fragment>
                )
            ) : (
              <React.Fragment>
                <p>{APP_TEXTS.DISCLAIMER_RAMSET_CONTENT_1.Content}</p>
              </React.Fragment>
          ))}
        </div>
      </section>
      {!isPrivacyPolicy && (
        <div className="default_popup-footer mt-2">
          <button
            className="btn btn-sm default_popup-button"
            onClick={close}
          >
            {APP_TEXTS.DISCLAIMER_AGREE.Content}
          </button>
        </div>
      )}
    </React.Fragment>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js